import type { CampaignMember } from '../../../_shared/launcher-campaign.types';
import { PushDrawer } from '../PushDrawer';
import { MemberDetailFields } from './MemberDetailFields';
import { memberDisplay } from './MemberRowCells';

/**
 * QA round 7, U7 (Playbooks item 13) — a Playbooks-native member detail
 * surface, replacing "copy the Launcher's `ContactModal`" (which is tailwind +
 * lucide + `_shared/Modal` — importable by nothing outside the Launcher lane,
 * `mini-apps/CLAUDE.md:14` — and doesn't even match Spencer's screenshot: its
 * Account header has no cloud icon and its Owner/Owner Role fields read dead
 * columns). Every field rendered below already lives on `CampaignMember`,
 * returned as-is by the shared `GET /api/tools/launcher/campaigns/:id/members`
 * endpoint both surfaces read — this is presentation only, no data change.
 *
 * `PushDrawer` (Playbooks' own side-surface primitive), not `_shared/Modal` —
 * consistent with every other Playbooks side panel (`SequenceMappingDrawer`,
 * `CreatePlaySidebar`), and it is the primitive the Launcher's own
 * `CampaignDetailSidebar` mirrors rather than the other way around.
 */

export function MemberDetailDrawer({ member, onClose }: { member: CampaignMember; onClose: () => void }) {
  const { email } = memberDisplay(member);

  return (
    <PushDrawer title={member.contact_name ?? 'Member'} subtitle={email || undefined} onClose={onClose}>
      <MemberDetailFields member={member} />
    </PushDrawer>
  );
}
